// src/tiles/SolutionTile.jsx
import React from 'react';
import { Stack, Typography, Box, Chip } from '@mui/material';
import TileShell from './TileShell';
import ReceiptsList from './ReceiptsList';
import ScoreBadge from './ScoreBadge';
import InterviewsBadge from './InterviewsBadge';

export default function SolutionTile({
  title,
  count,
  subtype,                 // 'previous' | 'considered'
  reasons = [],            // [{ reason, count, percent, importance, importanceLabel, receipts }]
  sectionTotal,
  justification
}) {
  const subtitle = subtype === 'previous' ? 'Switched due to:' : 'Rejected due to:';
  const pct = sectionTotal ? Math.round((count / sectionTotal) * 100) : 0;

  const metricsRow = (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
      <InterviewsBadge percent={pct} count={count} />
    </div>
  );

  const body = (
    <Stack spacing={1}>
      <Typography variant="body2" sx={{ fontWeight: 600 }}>{subtitle}</Typography>

      {/* Top 2 reasons only (tile-level limit) */}
      {reasons.slice(0, 2).map((r, i) => (
        <Stack key={i} spacing={0.5}>
          {/* Reason line */}
          <Typography variant="body2" component="div">
            • {r.reason}
          </Typography>

          {/* Per-reason pills: Interviews (count+%) first, then Importance (if any) */}
          <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 1, mb: 0.5 }}>
            {/* Interviews pill for the reason */}
            <InterviewsBadge count={r.count ?? 0} percent={r.percent ?? 0} showScale={false} />

            {/* Importance score chip (Considered only, if present) */}
            {subtype === 'considered' && r.importance != null && (
              <ScoreBadge
                label="Importance"
                value={r.importance}
                metricKey="reason_not_chosen_importance"
              />
            )}

          </Box>

          {/* Receipts for this reason (selector already caps to 2) */}
          <ReceiptsList receipts={r.receipts || []} />
        </Stack>
      ))}
    </Stack>
  );

  return (
    <TileShell
      typePill={subtype === 'previous' ? 'solution-prev' : 'solution-considered'}
      title={title}
      justification={justification}
      metricsRow={metricsRow}
      body={body}
    />
  );
}
